import React, { Component, PropTypes } from 'react';
import SteelCompass from 'services/SteelCompass';
import ClassNames from 'classnames';
import { RaisedButton, FlatButton } from 'material-ui';
import Message from 'services/Message';
import { maxFileSize } from 'Constants';

export default class FileUpload extends Component {
  static propTypes = {
    onSuccess: PropTypes.func,
    Element: PropTypes.func,
    multiple: PropTypes.bool,
    accept: PropTypes.string
  };

  static defaultProps = {
    multiple: false,
    accept: '*/*',
    Element: RaisedButton
  };

  handleFile(files) {
    if (files.length < 1) {
      return;
    }
    const current = files.pop();
    if (current) {
      const fileType = current.type;
      const encoded =
        fileType.indexOf('audio') === 0 || fileType.indexOf('video') === 0;
      SteelCompass.upload([current], {
        encoded,
        progress: event => {
          if (this.props.onProgress && event) {
            this.props.onProgress({
              ...event,
              remaining: files.length
            });
          }
        },
        error: () => {
          if (files.length > 0) {
            this.handleFile(files);
          }
        },
        success: response => {
          if (response && response.data && this.props.onSuccess) {
            this.props.onSuccess(response.data);
          }
          if (files.length > 0) {
            this.handleFile(files);
          }
        }
      });
    }
  }

  onChange(e) {
    this.processFiles(e.target.files);
  }

  processFiles(files) {
    const fileList = Object.keys(files).map(key => files[key]);
    const willBeUploaded = fileList.filter(file => file.size < maxFileSize);
    const willBeDropped = fileList.filter(file => file.size >= maxFileSize);
    if (willBeDropped.length > 0) {
      if (willBeDropped.length > 1) {
        Message.info(willBeDropped.length + ' files are too big.');
      } else {
        Message.info(willBeDropped.length + ' file is too big.');
      }
    }
    if (willBeUploaded.length > 0) {
      this.handleFile(willBeUploaded);
    }
  }

  handleClick() {
    this.refs.fileInput.value = null;
    this.refs.fileInput.click();
  }

  handleInputClick(e) {
    e.stopPropagation();
  }

  getStyle() {
    const { style } = this.props;
    return Object.assign(
      {
        position: 'relative'
      },
      style
    );
  }

  render() {
    let classes,
      { className, label, Element, ...other } = this.props;
    let inputStyle = {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      cursor: 'pointer',
      opacity: 0
    };
    return (
      <Element
        className={classes}
        {...other}
        style={this.getStyle()}
        label={label}
        onTouchTap={this.handleClick.bind(this)}
      >
        {this.props.children}
        <input
          onTouchTap={this.handleInputClick.bind(this)}
          style={inputStyle}
          ref="fileInput"
          type="file"
          onChange={this.onChange.bind(this)}
          multiple={this.props.multiple}
          accept={this.props.accept}
        />
      </Element>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/FileUpload.js